/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AvailableActions {
    CREATE = 'CREATE',
    EDIT = 'EDIT',
    SUBMIT = 'SUBMIT',
    DELETE = 'DELETE',
    RESUBMIT = 'RESUBMIT',
    EDIT_POSITION_CANCEL = 'EDIT_POSITION_CANCEL',
    EDIT_POSITION_DELETE = 'EDIT_POSITION_DELETE'
}
